export const apSelfAssessmentTranslations = {
    de: {
        title: 'Empfängersteuer',
        enable: 'Empfängersteuer prüfen',
        case: 'Gesetzlicher Steuerfall',
        reason: 'Prüfnachweis und Begründung',
        rate: 'Deutscher Steuersatz',
        sourcePosition: 'Originalanteil der Gutschrift',
        inputAccount: 'Konto abziehbare Vorsteuer',
        outputAccount: 'Konto geschuldete Umsatzsteuer',
        original: 'Steuer laut Original',
        legal: 'Selbst berechnete Umsatzsteuer',
        deductible: 'Zusätzlich abziehbare Vorsteuer',
        payable: 'Zahlbetrag an Lieferanten',
        residual: 'Verbleibender Zahlbetrag',
        cost: 'Aufwand / Anschaffungskosten',
        eligibility: 'Voraussetzungen dieses Steuerfalls, Unternehmereigenschaft, Leistungsort und Abzugsberechtigung geprüft; keine gesetzliche Ausnahme.',
        timing: 'Abgeschlossene Lieferung/Leistung: keine Anzahlung, keine fortlaufende Leistung über mehr als ein Jahr, kein Sonderzeitpunkt.',
        hint: 'Originalsteuersatz und Zahlbetrag bleiben erhalten. Wähle den deutschen Steuersatz und die beiden Steuerkonten je Anteil. Ein nicht abziehbarer Anteil erhöht die jeweiligen Kosten. Der Rechnungseingang verschiebt diese Steuer nicht.',
        cases: {
            IMPORT_GOODS_NO_RECIPIENT_VAT: 'Warenimport ohne Empfängersteuer; Einfuhrumsatzsteuer nur aus separatem Zollbeleg',
            FOREIGN_LOCAL_VAT_NO_RECIPIENT_VAT: 'Lokaler Auslandsumsatz; keine deutsche Empfängersteuer oder abziehbare Vorsteuer',
            EU_ACQUISITION: 'Innergemeinschaftlicher Erwerb von Waren (§ 1a)',
            EU_SERVICE: 'EU-B2B-Dienstleistung (§ 13b Abs. 1)',
            RC_FOREIGN_WORK_SERVICE: 'Ausländische Werklieferung / sonstige Leistung (§ 13b Abs. 2 Nr. 1)',
            RC_SECURITY: 'Sicherungsübereignung außerhalb Insolvenz (Nr. 2)',
            RC_PROPERTY: 'Grunderwerbsteuerpflichtiger Umsatz (Nr. 3)',
            RC_CONSTRUCTION: 'Bauleistung; Empfänger erbringt nachhaltig Bauleistungen (Nr. 4)',
            RC_FOREIGN_ENERGY: 'Ausländische Energielieferung nach § 3g (Nr. 5a)',
            RC_GAS: 'Erdgas an Wiederverkäufer (Nr. 5b)',
            RC_ELECTRICITY: 'Elektrizität zwischen Wiederverkäufern (Nr. 5b)',
            RC_EMISSIONS: 'Emissionsberechtigungen / Energiezertifikate (Nr. 6)',
            RC_SCRAP: 'Gegenstände nach Anlage 3; keine Differenzbesteuerung (Nr. 7)',
            RC_CLEANING: 'Gebäudereinigung; Empfänger erbringt nachhaltig Reinigung (Nr. 8)',
            RC_GOLD: 'Gold / Goldplattierung mit gesetzlicher Feinheit (Nr. 9)',
            RC_ELECTRONICS: 'Bestimmte Elektronik; Geschäftsvorgang ab 5.000 EUR (Nr. 10)',
            RC_METALS: 'Metalle nach Anlage 4; Geschäftsvorgang ab 5.000 EUR (Nr. 11)',
            RC_TELECOM: 'Telekommunikation an qualifizierten Wiederverkäufer (Nr. 12)',
        },
    },
    en: {
        title: 'Recipient VAT',
        enable: 'Review recipient VAT',
        case: 'Statutory tax case',
        reason: 'Review evidence and reason',
        rate: 'German VAT rate',
        sourcePosition: 'Original allocation for this credit',
        inputAccount: 'Deductible input VAT account',
        outputAccount: 'Output VAT payable account',
        original: 'Original supplier VAT',
        legal: 'Self-assessed output VAT',
        deductible: 'Additional deductible input VAT',
        payable: 'Payable to supplier',
        residual: 'Remaining amount payable',
        cost: 'Expense / acquisition cost',
        eligibility: 'Reviewed this case’s statutory conditions, business status, place of supply and deduction eligibility; no statutory exception applies.',
        timing: 'Completed supply: no advance, no continuous service exceeding one year and no special tax timing.',
        hint: 'The original VAT rate and supplier payable remain unchanged. Select a German rate and both tax accounts for each allocation. Non-deductible tax increases its allocated cost. Invoice receipt does not postpone this tax.',
        cases: {
            IMPORT_GOODS_NO_RECIPIENT_VAT: 'Imported goods without recipient VAT; customs VAT needs separate customs evidence',
            FOREIGN_LOCAL_VAT_NO_RECIPIENT_VAT: 'Local foreign supply; no German recipient or deductible input VAT',
            EU_ACQUISITION: 'Intra-community acquisition of goods (§ 1a)',
            EU_SERVICE: 'EU B2B service (§ 13b(1))',
            RC_FOREIGN_WORK_SERVICE: 'Foreign work supply / other service (§ 13b(2)1)',
            RC_SECURITY: 'Security transfer outside insolvency (no. 2)',
            RC_PROPERTY: 'Transaction subject to real estate transfer tax (no. 3)',
            RC_CONSTRUCTION: 'Construction; recipient regularly supplies construction (no. 4)',
            RC_FOREIGN_ENERGY: 'Foreign energy supply under § 3g (no. 5a)',
            RC_GAS: 'Natural gas supplied to reseller (no. 5b)',
            RC_ELECTRICITY: 'Electricity between resellers (no. 5b)',
            RC_EMISSIONS: 'Emission rights / energy certificates (no. 6)',
            RC_SCRAP: 'Annex 3 goods; no margin scheme (no. 7)',
            RC_CLEANING: 'Building cleaning; recipient regularly supplies cleaning (no. 8)',
            RC_GOLD: 'Gold / gold plating meeting statutory fineness (no. 9)',
            RC_ELECTRONICS: 'Specified electronics; transaction at least EUR 5,000 (no. 10)',
            RC_METALS: 'Annex 4 metals; transaction at least EUR 5,000 (no. 11)',
            RC_TELECOM: 'Telecommunications to qualified reseller (no. 12)',
        },
    },
    fr: {
        title: 'TVA due par le destinataire',
        enable: 'Vérifier la TVA du destinataire',
        case: 'Régime fiscal légal',
        reason: 'Justificatif du contrôle et motif',
        rate: 'Taux de TVA allemand',
        sourcePosition: 'Ventilation originale de cet avoir',
        inputAccount: 'Compte de TVA déductible',
        outputAccount: 'Compte de TVA due',
        original: 'TVA de la facture originale',
        legal: 'TVA autoliquidée',
        deductible: 'TVA déductible supplémentaire',
        payable: 'Montant dû au fournisseur',
        residual: 'Montant restant dû',
        cost: 'Charge / coût d’acquisition',
        eligibility: 'Conditions légales, qualité d’assujetti, lieu de prestation et droit à déduction vérifiés ; aucune exception légale.',
        timing: 'Livraison ou prestation achevée : aucun acompte, aucune prestation continue de plus d’un an et aucune échéance fiscale spéciale.',
        hint: 'Le taux original et la dette fournisseur restent inchangés. Sélectionnez le taux allemand et les deux comptes fiscaux par ventilation. La TVA non déductible augmente le coût correspondant. La réception de la facture ne reporte pas cette TVA.',
        cases: {
            IMPORT_GOODS_NO_RECIPIENT_VAT: 'Importation de biens sans autoliquidation ; TVA douanière justifiée séparément',
            FOREIGN_LOCAL_VAT_NO_RECIPIENT_VAT: 'Opération locale étrangère ; aucune TVA allemande autoliquidée ou déductible',
            EU_ACQUISITION: 'Acquisition intracommunautaire de biens (§ 1a)',
            EU_SERVICE: 'Prestation B2B dans l’UE (§ 13b(1))',
            RC_FOREIGN_WORK_SERVICE: 'Livraison d’ouvrage / prestation étrangère (§ 13b(2)1)',
            RC_SECURITY: 'Transfert à titre de garantie hors insolvabilité (n° 2)',
            RC_PROPERTY: 'Opération soumise aux droits de mutation immobilière (n° 3)',
            RC_CONSTRUCTION: 'Construction ; destinataire exerçant régulièrement cette activité (n° 4)',
            RC_FOREIGN_ENERGY: 'Énergie étrangère selon § 3g (n° 5a)',
            RC_GAS: 'Gaz naturel vendu à un revendeur (n° 5b)',
            RC_ELECTRICITY: 'Électricité entre revendeurs (n° 5b)',
            RC_EMISSIONS: 'Droits d’émission / certificats énergétiques (n° 6)',
            RC_SCRAP: 'Biens de l’annexe 3 ; hors régime de marge (n° 7)',
            RC_CLEANING: 'Nettoyage immobilier ; destinataire exerçant cette activité (n° 8)',
            RC_GOLD: 'Or / plaqué or de titre légal (n° 9)',
            RC_ELECTRONICS: 'Électronique désignée ; opération d’au moins 5 000 EUR (n° 10)',
            RC_METALS: 'Métaux de l’annexe 4 ; opération d’au moins 5 000 EUR (n° 11)',
            RC_TELECOM: 'Télécommunications à un revendeur qualifié (n° 12)',
        },
    },
    es: {
        title: 'IVA a cargo del destinatario',
        enable: 'Revisar el IVA del destinatario',
        case: 'Supuesto fiscal legal',
        reason: 'Justificante de revisión y motivo',
        rate: 'Tipo de IVA alemán',
        sourcePosition: 'Asignación original de este abono',
        inputAccount: 'Cuenta de IVA deducible',
        outputAccount: 'Cuenta de IVA devengado',
        original: 'IVA de la factura original',
        legal: 'IVA autorrepercutido',
        deductible: 'IVA deducible adicional',
        payable: 'Importe pendiente al proveedor',
        residual: 'Importe restante por pagar',
        cost: 'Gasto / coste de adquisición',
        eligibility: 'Revisados los requisitos legales, la condición empresarial, el lugar de prestación y el derecho a deducción; no concurre ninguna excepción legal.',
        timing: 'Entrega o servicio completado: sin anticipo, sin prestación continua de más de un año ni devengo especial.',
        hint: 'Se conservan el tipo original y la deuda con el proveedor. Seleccione el tipo alemán y ambas cuentas fiscales por reparto. El IVA no deducible aumenta el coste correspondiente. Recibir la factura más tarde no aplaza este IVA.',
        cases: {
            IMPORT_GOODS_NO_RECIPIENT_VAT: 'Importación de bienes sin inversión del sujeto pasivo; IVA aduanero con justificante separado',
            FOREIGN_LOCAL_VAT_NO_RECIPIENT_VAT: 'Operación local extranjera; sin IVA alemán autorrepercutido ni deducible',
            EU_ACQUISITION: 'Adquisición intracomunitaria de bienes (§ 1a)',
            EU_SERVICE: 'Servicio B2B de la UE (§ 13b(1))',
            RC_FOREIGN_WORK_SERVICE: 'Entrega de obra / servicio extranjero (§ 13b(2)1)',
            RC_SECURITY: 'Transmisión en garantía fuera de insolvencia (n.º 2)',
            RC_PROPERTY: 'Operación sujeta al impuesto de transmisiones inmobiliarias (n.º 3)',
            RC_CONSTRUCTION: 'Construcción; destinatario que presta habitualmente estos servicios (n.º 4)',
            RC_FOREIGN_ENERGY: 'Suministro extranjero de energía según § 3g (n.º 5a)',
            RC_GAS: 'Gas natural a revendedor (n.º 5b)',
            RC_ELECTRICITY: 'Electricidad entre revendedores (n.º 5b)',
            RC_EMISSIONS: 'Derechos de emisión / certificados energéticos (n.º 6)',
            RC_SCRAP: 'Bienes del anexo 3; sin régimen de margen (n.º 7)',
            RC_CLEANING: 'Limpieza de edificios; destinatario dedicado habitualmente a ella (n.º 8)',
            RC_GOLD: 'Oro / chapado de oro con pureza legal (n.º 9)',
            RC_ELECTRONICS: 'Electrónica especificada; operación de al menos 5.000 EUR (n.º 10)',
            RC_METALS: 'Metales del anexo 4; operación de al menos 5.000 EUR (n.º 11)',
            RC_TELECOM: 'Telecomunicaciones a revendedor cualificado (n.º 12)',
        },
    },
    tr: {
        title: 'Alıcının hesapladığı KDV',
        enable: 'Alıcının KDV yükümlülüğünü incele',
        case: 'Yasal vergi durumu',
        reason: 'İnceleme kanıtı ve gerekçe',
        rate: 'Almanya KDV oranı',
        sourcePosition: 'Bu alacak belgesinin asıl dağıtım satırı',
        inputAccount: 'İndirilebilir KDV hesabı',
        outputAccount: 'Ödenecek KDV hesabı',
        original: 'Asıl faturadaki KDV',
        legal: 'Alıcının hesapladığı KDV',
        deductible: 'Ek indirilebilir KDV',
        payable: 'Tedarikçiye ödenecek tutar',
        residual: 'Kalan ödenecek tutar',
        cost: 'Gider / edinme maliyeti',
        eligibility: 'Yasal koşullar, işletme niteliği, hizmet yeri ve indirim hakkı incelendi; yasal istisna yok.',
        timing: 'Tamamlanmış teslim/hizmet: avans, bir yılı aşan sürekli hizmet veya özel vergi zamanı yok.',
        hint: 'Asıl oran ve tedarikçi borcu korunur. Her dağılım için Alman vergi oranını ve iki vergi hesabını seçin. İndirilemeyen vergi ilgili maliyeti artırır. Faturanın geç alınması bu vergiyi ertelemez.',
        cases: {
            IMPORT_GOODS_NO_RECIPIENT_VAT: 'Alıcı KDV’siz mal ithalatı; ithalat KDV’si için ayrı gümrük belgesi gerekir',
            FOREIGN_LOCAL_VAT_NO_RECIPIENT_VAT: 'Yurt dışındaki yerel işlem; Alman alıcı KDV’si veya indirilebilir KDV yok',
            EU_ACQUISITION: 'AB içi mal edinimi (§ 1a)',
            EU_SERVICE: 'AB işletmeler arası hizmet (§ 13b(1))',
            RC_FOREIGN_WORK_SERVICE: 'Yabancı iş teslimi / diğer hizmet (§ 13b(2)1)',
            RC_SECURITY: 'İflas dışında teminat devri (no. 2)',
            RC_PROPERTY: 'Gayrimenkul devir vergisine tabi işlem (no. 3)',
            RC_CONSTRUCTION: 'İnşaat; alıcı düzenli inşaat hizmeti sunar (no. 4)',
            RC_FOREIGN_ENERGY: '§ 3g kapsamında yabancı enerji teslimi (no. 5a)',
            RC_GAS: 'Yeniden satıcıya doğal gaz (no. 5b)',
            RC_ELECTRICITY: 'Yeniden satıcılar arasında elektrik (no. 5b)',
            RC_EMISSIONS: 'Emisyon hakları / enerji sertifikaları (no. 6)',
            RC_SCRAP: 'Ek 3 malları; marj vergilendirmesi yok (no. 7)',
            RC_CLEANING: 'Bina temizliği; alıcı düzenli temizlik hizmeti sunar (no. 8)',
            RC_GOLD: 'Yasal saflıkta altın / altın kaplama (no. 9)',
            RC_ELECTRONICS: 'Belirli elektronik; en az 5.000 EUR tutarında işlem (no. 10)',
            RC_METALS: 'Ek 4 metalleri; en az 5.000 EUR tutarında işlem (no. 11)',
            RC_TELECOM: 'Nitelikli yeniden satıcıya telekomünikasyon (no. 12)',
        },
    },
};
//# sourceMappingURL=ap-self-assessment.js.map